import { useMemo } from 'react';
import moment from 'moment-timezone';
import { isAsapTelemedBooking, isOnlineWaitlistBooking } from '~/core/util/booking';
import {
  bookAheadTimeFormats,
  timeFormatAsapTelemed,
  timeFormatOnlineWaitlist,
  walkInTimeFormats,
} from '~/components/AccountGetsMarried/constants/timeFormatsForBooking';

/**
 * Hook for determining what string copy to display on appointment card.
 *
 * @param appointment {any} the appointment object
 * @returns {string} copy to display on appointment card
 */

export default (appointment: any) => {
  const isWalkIn = appointment.is_walkin;

  let timeFormats: any;
  if (isAsapTelemedBooking(appointment)) {
    timeFormats = timeFormatAsapTelemed;
  } else if (isOnlineWaitlistBooking(appointment)) {
    timeFormats = timeFormatOnlineWaitlist;
  } else if (isWalkIn) {
    timeFormats = walkInTimeFormats;
  } else {
    timeFormats = bookAheadTimeFormats;
  }

  const appointmentTime = isWalkIn
    ? appointment.arrived_timestamp
    : appointment.original_appointment_date;

  const timeZone = appointment.time_zone;

  return useMemo(() => {
    return moment(appointmentTime).tz(timeZone).calendar(null, timeFormats);
  }, [appointmentTime, timeFormats, timeZone]);
};
